











import Vue from 'vue';
import Loader from '../components/Loader.vue';
import Launchers from '../components/Launchers.vue';
import LaunchedApp from '../components/LaunchedApp.vue';
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import store from '../store';
import ScreenSaver from '../components/ScreenSaver.vue';

window.KioskShouldDisableIdleTimer = function () {
  // close out the active app and show the screensaver
  store.dispatch('resetDueToInactivity');

  // Tell kiosk pro to skip the idle timer
  return 'YES';
};

export default Vue.extend({
  created() {
    this.initialize();
  },

  watch: {
    $route: 'initialize',
  },

  computed: {
    ...mapState(['kiosk', 'loading', 'active']),
    ...mapGetters(['screenSaverURL']),

    shouldShowScreenSaver(): boolean {
      if (!this.screenSaverURL) {
        return false;
      }

      return !this.active;
    },
  },

  methods: {
    ...mapActions(['initialize']),
    ...mapMutations(['setActive']),
  },

  components: {
    ScreenSaver,
    Loader,
    Launchers,
    LaunchedApp,
  },
});
